"use client";

import type { Pages } from "@packages/sdk";
import { useRequestSection } from "@packages/sdk";
import { Section, Sections } from "@packages/ui";

export type SectionClientProps = {
  initialData: Pages;
  id: string;
};

export const SectionClient = ({ id, initialData }: SectionClientProps) => {
  const { query: querySections } = useRequestSection({
    id,
    initialData,
  });

  return (
    <Sections title={querySections.data?.title}>
      <Section section={querySections.data} />
    </Sections>
  );
};
